/**
 * Dealer placement real estate IDs. Single source of truth for all placements.
 * Used by placement components and by da-wix-dealer (e.g. MESSAGES_REAL_ESTATE_ID for compact card styling).
 */

/** Messages (Watch) mobile modal. Used for Messages-only design (compact card). */
export const MESSAGES_REAL_ESTATE_ID =
  'bdc5d9fa-76b1-42fc-80c6-a4935869f935';

/** Site header – logged-in users */
export const SITE_HEADER_LOGGED_IN_REAL_ESTATE_ID =
  '7762cc44-45ad-436a-b170-f4dc4426f5ae';

/** Site header – anonymous users */
export const SITE_HEADER_ANON_REAL_ESTATE_ID =
  '862f0865-3b30-4936-ae6b-a24fb0d1f330';

/** Global modal (desktop) */
export const GLOBAL_MODAL_REAL_ESTATE_ID =
  '97b2237b-f469-4a05-929e-00306ae7da8a';

/** Dreamup sidebar */
export const DREAMUP_SIDEBAR_REAL_ESTATE_ID =
  '2f2231c2-d516-40f2-8921-74a3bf9905d1';

/** Devpage sidebar – logged-in users */
export const DEVPAGE_SIDEBAR_LOGGED_IN_REAL_ESTATE_ID =
  '8705520c-14b7-48a0-b681-766bab417d53';

/** Devpage sidebar – anonymous users */
export const DEVPAGE_SIDEBAR_ANON_REAL_ESTATE_ID =
  'b912510c-e850-43c0-bcf6-50e1674f0c2c';

/** Devpage adhesion */
export const DEVPAGE_ADHESION_REAL_ESTATE_ID =
  '166926a9-15ab-458d-b424-4385d5c9acde';

/** Studio products catalog card A */
export const STUDIO_PRODUCTS_CATALOG_CARD_A_REAL_ESTATE_ID =
  '9cf590fc-df94-4528-9a00-2810d2cddaaf';

/** Studio products catalog card B */
export const STUDIO_PRODUCTS_CATALOG_CARD_B_REAL_ESTATE_ID =
  '7937b196-3bb6-42b3-93e9-ff7df06fc953';

/** Studio products catalog card C */
export const STUDIO_PRODUCTS_CATALOG_CARD_C_REAL_ESTATE_ID =
  'a3d0b02e-5b2f-4587-a4a3-f606e05cf067';

/** Studio products catalog card D */
export const STUDIO_PRODUCTS_CATALOG_CARD_D_REAL_ESTATE_ID =
  'daa724fe-f594-4591-ac91-e91d70020d0e';

/** Studio products catalog card E */
export const STUDIO_PRODUCTS_CATALOG_CARD_E_REAL_ESTATE_ID =
  '34a38aec-f4df-4434-b76c-ceb291fc97c9';

/** Studio products catalog card F */
export const STUDIO_PRODUCTS_CATALOG_CARD_F_REAL_ESTATE_ID =
  'd6bb48e9-632d-4525-8423-10aa20ef3156';

/** Studio playground placement A */
export const STUDIO_PLAYGROUND_PLACEMENT_A_REAL_ESTATE_ID =
  '34067f70-0ff1-4761-8398-c8ca0c39f5ca';

/** Studio playground placement B */
export const STUDIO_PLAYGROUND_PLACEMENT_B_REAL_ESTATE_ID =
  '860d49c8-b56e-43be-92f0-9d91c1748bc2';

/** Studio playground placement C */
export const STUDIO_PLAYGROUND_PLACEMENT_C_REAL_ESTATE_ID =
  '7d3e037b-d415-49ac-8f33-f0684c604fda';
